import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  // if (loading) {
  //   return <h1 className="text-5xl text-warning text-center">Loading...</h1>;
  // }
  if (localStorage.getItem("usersInfo")) {
    return <div>{children}</div>;
  }

  return <Navigate to="/login" state={{ from: location }} replace></Navigate>;
};

export default PrivateRoute;
